import { combineReducers } from 'redux'

import eventAnalysis from './eventAnalysis'
import eventTracker from './eventTracker'

export default combineReducers({
  eventAnalysis,
  eventTracker,
})
